export const formatTimelineDate = (value) => {
  if (!value) return "Recently";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Recently";

  return date.toLocaleString([], {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

const normalizeExternalEvents = (items = [], config = {}) => {
  return items.map((item, index) => ({
    id: item.id || item._id || `${config.type || "event"}-${index}`,
    type: config.type || item.type || "note",
    typeLabel: config.typeLabel || item.typeLabel || "Activity",
    title: item.title || config.defaultTitle || "Activity updated",
    description: item.description || config.defaultDescription || "",
    timestamp: item.timestamp || item.createdAt || item.updatedAt || null,
    timeLabel: item.timeLabel || formatTimelineDate(item.timestamp || item.createdAt || item.updatedAt),
  }));
};

export const buildStudentTimelineEvents = ({
  formData,
  allMissingDocs = [],
  messages = [],
  attendance = [],
  reminders = [],
  incidents = [],
  notes = [],
}) => {
  const profileEvents = [
    ...(formData?.documents || []).map((doc, index) => ({
      id: `document-${doc._id || index}`,
      type: "document",
      typeLabel: "Document",
      title: doc.title || doc.name || "Document uploaded",
      description: "Compliance document added to the student record.",
      timestamp: doc.uploadedAt || null,
      timeLabel: formatTimelineDate(doc.uploadedAt),
    })),

    ...(formData?.healthDocuments || []).map((doc, index) => ({
      id: `health-document-${doc._id || index}`,
      type: "document",
      typeLabel: "Health Document",
      title: doc.title || doc.name || "Health document uploaded",
      description: "Health-related record added to the student profile.",
      timestamp: doc.uploadedAt || null,
      timeLabel: formatTimelineDate(doc.uploadedAt),
    })),

    ...(allMissingDocs.length
      ? [
          {
            id: "missing-documents-alert",
            type: "reminder",
            typeLabel: "Reminder",
            title: "Missing documents",
description: `${allMissingDocs.length} item${allMissingDocs.length === 1 ? "" : "s"} need attention.`,
            timestamp: new Date().toISOString(),
            timeLabel: "Needs attention",
          },
        ]
      : []),

    ...(formData?.healthRecords
      ? [
          {
            id: "health-notes",
            type: "note",
            typeLabel: "Health Note",
            title: "Health notes updated",
            description: "Health and care information is present on the student profile.",
            timestamp: new Date().toISOString(),
            timeLabel: "Current profile data",
          },
        ]
      : []),

    ...(formData?.documentsNote
      ? [
          {
            id: "compliance-notes",
            type: "note",
            typeLabel: "Compliance Note",
            title: "Compliance notes added",
            description: "Enrollment or compliance notes exist for this student.",
            timestamp: new Date().toISOString(),
            timeLabel: "Current profile data",
          },
        ]
      : []),
  ];

  const messageEvents = normalizeExternalEvents(messages, {
    type: "message",
    typeLabel: "Message",
    defaultTitle: "Message sent",
  });

  const attendanceEvents = normalizeExternalEvents(attendance, {
    type: "attendance",
    typeLabel: "Attendance",
    defaultTitle: "Attendance recorded",
  });

  const reminderEvents = normalizeExternalEvents(reminders, {
    type: "reminder",
    typeLabel: "Reminder",
    defaultTitle: "Reminder created",
  });

  const incidentEvents = normalizeExternalEvents(incidents, {
    type: "incident",
    typeLabel: "Incident",
    defaultTitle: "Incident logged",
  });

  const noteEvents = normalizeExternalEvents(notes, {
    type: "note",
    typeLabel: "Note",
    defaultTitle: "Note added",
  });

  return [
    ...profileEvents,
    ...messageEvents,
    ...attendanceEvents,
    ...reminderEvents,
    ...incidentEvents,
    ...noteEvents,
  ].sort((a, b) => {
    const aTime = a.timestamp ? new Date(a.timestamp).getTime() : 0;
    const bTime = b.timestamp ? new Date(b.timestamp).getTime() : 0;
    return bTime - aTime;
  });
};